/**=========================================================
 * Module: filter-by-date.js
 * Services to share filter by date functions
 =========================================================*/

App.service('filterByDate', function($rootScope, datesInTimezone) {
  return {
    toggleFilter (scope, value, force_open = false) {
      if(force_open) {
        scope[value] = true
      } else {
        scope[value] = !scope[value]
      }
      if(value == 'sentdate' && !scope[value]) {
        delete scope.search_by_date.sentdate_before
        delete scope.search_by_date.sentdate_after
      }
      if(value == 'apptdate' && !scope[value]) {
        delete scope.search_by_date.apptdate_before
        delete scope.search_by_date.apptdate_after
      }
    },

    clearFilterDateRange(scope) {
      scope.dateRangePicker.created_at = { startDate: null, endDate: null }
      scope.load_daterange_filter_init = false
    },

    initDateRangePicker(scope) {
      scope.dateRangePicker = {
        options: {
          locale: {
            format: 'MMM D, YYYY',
            cancelLabel: 'Clear'
          },
          showDropdowns: true,
          opens: 'left',
          eventHandlers: {
            'cancel.daterangepicker': (evt, picker) => {
              this.clearFilterDateRange(scope)
              scope.load_daterange_filter_init = true
            }
          }
        }
      }

      this.clearFilterDateRange(scope)

      scope.$watch('dateRangePicker.created_at', () => {
        daterange_changed = true
        if (scope.dateRangePicker.created_at && scope.dateRangePicker.created_at.startDate && scope.dateRangePicker.created_at.endDate) {
          if (scope.created_at_start == scope.dateRangePicker.created_at.startDate && scope.created_at_end == scope.dateRangePicker.created_at.endDate) {
            daterange_changed = false
          } else {
            converted_dates = datesInTimezone.convertToInstTimezone(scope.dateRangePicker.created_at.startDate, scope.dateRangePicker.created_at.endDate, false)
            scope.created_at_start = converted_dates[0]
            scope.created_at_end = converted_dates[1]
          }
        } else {
          if (!scope.created_at_start && !scope.created_at_end) {
            daterange_changed = false
          } else {
            scope.created_at_start = scope.created_at_end = null
          }
        }

        if (!scope.load_daterange_filter_init) {
          scope.load_daterange_filter_init = true
        } else if (daterange_changed && scope.tableParams) {
          scope.tableParams.page(1)
          scope.tableParams.reload()
        }
      })
    }
  }
})
